import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { OrganizationProject } from 'app/fs/res/finance/model/project/project-classes';
import { HisBaseGlobalsService } from 'hisng';

@Component( {

    selector: 'res-organization-information-dialog',
    templateUrl: './organization-information-dialog.component.html'
} )

export class OrganizationInformationDialogComponent implements OnChanges {
  @Input() visibility = false;
  @Output() visibilityChange: EventEmitter<boolean> = new EventEmitter();

  @Input() organization: OrganizationProject;
  @Output() organizationChange: EventEmitter<OrganizationProject> = new EventEmitter();

  public information: string;

  constructor( public hisBaseGlobalsService: HisBaseGlobalsService ) {
  }
  
  ngOnChanges( changes: SimpleChanges ): void {
      if(changes.organization && changes.organization.currentValue) {
          this.information = changes.organization.currentValue.information;
      }
  }

  saveDialog() {
      this.organization.information = this.information;
      this.organizationChange.emit( this.organization );
      this.visibilityChange.emit( false );
  }

  closeDialog() {
      this.information = this.organization.information;
      this.visibilityChange.emit( false );
  }

}
